export enum KnowledgeResource {
  Questions = 'questions',
  Answers = 'answers',
  Sources = 'sources',
  Tags = 'tags'
}
